import * as React from "react";

const SvgIcon: React.FC<React.SVGProps<SVGElement>> = ({ width = 30, height = 30 }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={width}
        height={height}
        fill="none"
        viewBox="0 0 30 30"
    >
        <path fill="url(#pattern0_1_201)" d="M0 0h30v30H0z"></path>
        <defs>
            <pattern
                id="pattern0_1_201"
                width="1"
                height="1"
                patternContentUnits="objectBoundingBox"
            >
                <use xlinkHref="#image0_1_201" transform="scale(.01)"></use>
            </pattern>
            <image
                xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADnUlEQVR4nO3dTahNaxzH8eVKt5u3Wwa3FCWUl4Ebt2QgpchIkd1Zz39tiTjdFCXOef7rGOwM5GWEEaWw1/9Zp3YpUgYmRhQpEwPKvTK45YoQktejdU4k8nL2fo7nf9b6feqZnfZ51vNda6/2XnuvHUUAAAAAAADwVT3HN01koe3WmSY7an1rFH9j83hbo1Wb8PVHhLZxsz6Lhe6wo4HhDOvMv7v6u2Zi6X0aiMawo2vDjfFxCF0pHgNRPOkT+rPtGB+OlGZ9AYJ4kgqt7ThIlqxBEE/YUa3TIMVjIAiClBPjCNGFEUQXRhBdGEF0YQTRhRFEF0YQXRhBdGEE0YURRBdGEF0YQXRhBNGFEUQXRhBdGEF0YQTRhRFEF0YQXRhBdGEE0YURRBdGEF0YQXRhBNGFEUQXRhBdGEF0YQTRhRHEP9uqTe7LkoXsaFEbw3r4foht538Xc25kyaSoTNiZjVbopYdFHQgxBueeJRuismBn/g+9qNx5lHtRWbCjf0IvKHc6hG5HZcFZstI682LUHh3OvOjN4xVRmaTOLLPOPAm9uDzsYZ6VLsYHPXn8l3XmwSg6Mh6xM0uiMkuzZB4L/ac+htC9ytxsYHezPkP3id7c7XFmdlQl9tT66VbolsIYN3f3d02LqijN4z+sM9fDR6ChIXSjJ4+nRlXWOLHhdxa6FDqGdeYqn1o/JfR6qLCzWR/PQhcCPk1dLG6OFnodVNl2ftWv1pnTAY6Mcztatd9Cb79KtVZtrHXm5E+LIZR3H+seF3q7dRuIxlhnDo94EKGjjUbjl9CbO3pu6Sd0cASfpg7gln9tYD8Xpj4f+/3vQRXCzmy1zrz18BT1zgrtCL09pWDzuG6FXncQ443Nkk2ht6NUOEtWt3NNpbj8mmbJutDzLyWbx8ut0NNhnLyfcx6vCj3vUkuzZCkLPf6BI+NpETD0fCuhL0sWWqH73zhnPOQ8Xhx6npWSDl3o+vJe8EJ3evu75oaeXyU1WrUJLLTHCl0efMdYaE/xRmXoeQEAAAAAAAAAAMAnevN4fvEBARbq/97PnmLQ0BoUayW0r3hn2uvOxEJ/d3RNu+LDCr1OhbZ4+5VNxCAvUbx8AYiFjoTew7gsQ+hQx0GsM2eDb4gryzBnfAQZ+c/ZVmWIjyOkWV+AcwjpOYcU2FE3O/Mq+B7mRuswr6wzmyOfik9ysNDe4jsVeJ1BP/Raa3CthPamzszxGgMAAAAAACDy5z102puTMbA1qwAAAABJRU5ErkJggg=="
                id="image0_1_201"
                width="100"
                height="100"
                preserveAspectRatio="none"
            ></image>
        </defs>
    </svg>
);

export default React.memo(SvgIcon);
